import { Link } from "react-router-dom";
import { CheckCircle2, Circle, FolderKanban } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { spaceOf } from "@/lib/spaces";
import { fromNow } from "@/lib/time";
import { SpaceAvatar } from "@/components/SpaceAvatar";
import { ItemMenu } from "@/components/Bits";

export const NoteCard = ({ n, showProject = true }) => {
  const { run, openEdit } = useApp();
  const thought = n.kind === "thought";
  const toggle = () => run(() => api.patch(`/notes/${n.id}`, { discussed: !n.discussed }), n.discussed ? "Back on the list" : "Marked as discussed");
  const remove = () => run(() => api.delete(`/notes/${n.id}`), "Deleted");

  return (
    <article data-testid={`${thought ? "thought" : "note"}-card-${n.id}`}
      className={`group mb-4 break-inside-avoid rounded-xl border bg-background/40 p-4 transition-colors hover:border-white/20 ${n.discussed ? "opacity-60" : ""}`}
      style={thought ? { borderLeft: `3px solid ${spaceOf(n.space).color}` } : {}}>
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          {n.title && <h3 className={`font-semibold leading-snug ${n.discussed ? "line-through" : ""}`}>{n.title}</h3>}
          <p className={`whitespace-pre-wrap text-sm ${n.title ? "mt-1 text-muted-foreground" : ""}`}>{n.body}</p>
        </div>
        <ItemMenu testid={`note-${n.id}`} onEdit={() => openEdit(n.kind, n)} onDelete={remove} />
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-muted-foreground">
        <SpaceAvatar space={n.space} />
        <span>{spaceOf(n.created_by).name} · {fromNow(n.created_at)}</span>
        {showProject && n.project_title && (
          <Link to={`/projects/${n.project_id}`} className="flex items-center gap-1 hover:text-foreground"><FolderKanban className="h-3 w-3" /> {n.project_title}</Link>
        )}
        {thought && (
          <button onClick={toggle} data-testid={`thought-toggle-discussed-${n.id}`}
            className={`ml-auto flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-semibold transition-colors ${n.discussed ? "border-emerald-500/40 text-emerald-300" : "hover:border-emerald-500/40 hover:text-emerald-300"}`}>
            {n.discussed ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
            {n.discussed ? "Discussed" : "Mark discussed"}
          </button>
        )}
      </div>
    </article>
  );
};
